import { ClassesBody } from 'modules/arena/reports/model/bodies';
import { KpiGrid } from 'modules/arena/reports/components/KpiCard';
import { Panel } from 'modules/arena/reports/components/Panel';
import { DataTable } from 'modules/arena/reports/components/DataTable';
import { OccupancyHeatmap } from 'modules/arena/reports/components/OccupancyHeatmap';
import { AreaProps } from 'modules/arena/reports/areas/shared';

export function ClassesArea({ body, meta, controller }: AreaProps<ClassesBody>) {
  const { changeTable, tableLoading } = controller;
  return (
    <div className="flex flex-col gap-8">
      <section aria-labelledby="aulas-realizadas">
        <h3 id="aulas-realizadas" className="font-heading text-base font-semibold text-ink">
          Aulas do período
        </h3>
        <p className="mb-3 text-sm text-ink-secondary">Apenas aulas que já aconteceram — as futuras ficam no bloco abaixo, separadas.</p>
        <KpiGrid metrics={body.metrics} meta={meta} />
      </section>

      <div className="grid grid-cols-1 gap-6 xl:grid-cols-[1.2fr_1fr]">
        <Panel title="Ocupação por dia e faixa de horário" subtitle="Presenças sobre vagas das aulas realizadas">
          <OccupancyHeatmap heatmap={body.heatmap} caption="Ocupação das aulas por dia da semana e faixa de horário" />
        </Panel>
        <Panel title="Próximos 7 dias" subtitle="Agenda futura: ainda sem presença registrada, não entra nos indicadores acima">
          <KpiGrid metrics={body.upcoming.metrics} meta={meta} />
        </Panel>
      </div>

      <DataTable
        title="Turmas no período"
        table={body.table}
        loading={tableLoading}
        onChange={changeTable}
        footnote="Ocupação = presenças sobre vagas das aulas realizadas. “Indisponível” na espera indica turma sem registro de fila."
      />
      <DataTable title="Próximas aulas" table={body.upcoming.table} footnote="Confirmações até agora; podem mudar até o horário da aula." />
    </div>
  );
}
